import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminTrackingIntegrations = lazy(() => import("@/pages/admin/AdminTrackingIntegrations"));

export const Route = createFileRoute("/admin/tracking")({
  component: AdminTrackingIntegrations,
});
